import React, { useRef } from "react";
import HandDetect from "./HandDetcect"
import "./App.css";


function App() {


  return (
    <div className="App">
    <HandDetect/>
    </div>
  );
}

export default App;